import { render } from "./DockerLimitResource.vue?vue&type=template&id=387d1256"
import script from "./DockerLimitResource.vue?vue&type=script&lang=js"
export * from "./DockerLimitResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__